<template>
    <el-steps
        direction="vertical"
        :active="active"
        finish-status="success"
        space="80px"
        class="col-block"
    >
        <el-step :title="step.label" v-for="(step, index) of workflow" :key="index">
            <el-button
                :type="workflowEnum[step.type][step.status].status"
                size="mini"
                slot="description"
                :disabled="step.disabled"
                @click="backData(step, index)"
            >{{ workflowEnum[step.type][step.status].description }}</el-button>
        </el-step>
    </el-steps>
</template>

<script>
export default {
    name: "step",
    props: {
        workflow: {
            type: Array,
            default: () => []
        },
        isAutoDisabled: { type: Boolean, default: false }
    },
    data() {
        return {
            isChanging: false,
            // 審查狀態，比照/CUCLROC_Official/Commom/Configuration.cs
            workflowEnum: {
                0: {
                    0: {
                        status: "",
                        description: ""
                    },
                    1: {
                        status: "",
                        description: ""
                    },
                    2: {
                        status: "",
                        description: ""
                    }
                },
                1: {
                    0: {
                        status: "error",
                        description: "未填寫"
                    },
                    1: {
                        status: "primary",
                        description: "填寫中"
                    },
                    2: {
                        status: "success",
                        description: "填寫完成"
                    },
                    3: {
                        status: "danger",
                        description: "中止"
                    }
                },
                2: {
                    0: {
                        status: "error",
                        description: "等待中"
                    },
                    1: {
                        status: "primary",
                        description: "審查中"
                    },
                    2: {
                        status: "success",
                        description: "通過"
                    },
                    3: {
                        status: "error",
                        description: "不通過"
                    },
                    4: {
                        status: "default",
                        description: "中止"
                    }
                },
                3: {
                    0: {
                        status: "error",
                        description: "未處理"
                    },
                    1: {
                        status: "success",
                        description: "已處理"
                    }
                },
                4: {
                    0: {
                        status: "info",
                        description: "下一步"
                    }
                }
            },
            active: 0
        };
    },
    watch: {
        workflow() {
            this.findActive();
            if (this.isAutoDisabled && !this.isChanging) {
                //避免無窮迴圈
                this.isChanging = true;
                this.autoDisabled();
                this.isChanging = false;
            }
        }
    },
    methods: {
        autoDisabled() {
            this.workflow.forEach(flow => {
                let errorStringArray = ["不通過", "中止"];
                if (
                    errorStringArray.includes(
                        this.workflowEnum[flow.type][flow.status].description
                    )
                ) {
                    flow["disabled"] = true;
                }
            });
        },
        backData(item, index) {
            let key = "";
            this.workflow.find((item, idx) => {
                if (item.status == 1) {
                    key = idx;
                }
            });
            if (key == "") {
                this.workflow.every(item => {
                    if (item.status == 2) {
                        key = this.workflow.length;
                    }
                });
            }
            if (index <= key) {
                this.$emit("goForm", item, index);
            } else {
                this.$message.closeAll();
                this.$message({
                    type: "warning",
                    message: "尚未到此審核步驟",
                    duration: 5000
                });
            }
        },
        findActive() {
            this.active = this.workflow.findIndex(val => {
                if (val.status == 1) {
                    return val;
                }
            });
        }
    }
};
</script>
